module.exports = __webpack_public_path__ + "img/social-image.04aea7a5.png";